import React, { Component } from 'react';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import ReadingList from '../../../../Components-2025/QuestionBank/ReadingList';
import ComponentHeader from '../../../../common/ComponentHeader';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import { showFailure, showInformation } from '../../../../common/toast';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import appRoutes from '../../../config/AppRoutes';
import alertMessage from '../../../config/alertMessage';
import {
  TotalNotesCountKey,
  chapterIdKey,
  chapterNameKey,
  chapterOrderKey,
} from './ApiAttributesKeys';
import apiServiceProvider from './ApiService';

/* eslint-disable*/

export default class ReadingsList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      selectedExamSubscriptionDetails: {},
      chapterName: '',
      chapterOrder: 0,
      pdfAlert: false,
      openPremiumPopup: false,
      isUserSubscribed: false,
      readingListData: [],
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { chapterId, level } = this.props.params;
    const fetchReadingListData = await apiServiceProvider['fetchReadingList']({ chapterId, level });
    if (fetchReadingListData.success) {
      const { readings, selectedExamSubscriptionDetails, chapterName } = fetchReadingListData;
      if (
        (selectedExamSubscriptionDetails.level1SubscriptionDetails &&
          selectedExamSubscriptionDetails.level1SubscriptionDetails.noteStatus) ||
        parseInt(chapterId, 10) === 1
      ) {
        this.setState({});
        this.setState({
          readingListData: readings,
          isUserSubscribed: !!selectedExamSubscriptionDetails.level1SubscriptionDetails,
          selectedExamSubscriptionDetails,
          isLoading: false,
          chapterName: Object.keys(chapterName).length && chapterName[chapterNameKey],
          chapterOrder: Object.keys(chapterName).length && chapterName[chapterOrderKey],
        });
      } else {
        const { router } = this.context;
        router.push({ pathname: nextAwareRoute(appRoutes.CFA1_2025_NOTES) });
        showFailure(messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER);
      }
    }
  }
  checkSubscription = async (cb, type) => {
    const { isUserSubscribed } = this.state;
    if (!isUserSubscribed) {
      return this.setState({ openPremiumPopup: true });
    }
    // Only show the "export initiated" success modal when the API actually
    // accepted the request. A missing/ungenerated PDF returns { success:false,
    // status:404 } — previously the modal was shown regardless, falsely telling
    // the user an email was on the way.
    const response = await cb();
    if (response && response.success) {
      this.setState({ PDFDownloadType: type });
      this.pdfAlertModel();
    } else {
      showFailure(
        (response && response.message) || messages.PDF_DOWNLOAD_NOT_AVAILABLE,
      );
    }
  };

  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };

  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };

  pdfAlertModel = () => {
    this.setState({ pdfAlert: !this.state.pdfAlert });
  };

  onBeginChapter = items => {
    const { isUserSubscribed } = this.state;
    const { chapterId } = this.props.params;
    if (!items[TotalNotesCountKey]) {
      showInformation(messages.NOTES_NOT_AVAILABLE_FOR_READING);
    } else {
      if (!isUserSubscribed && parseInt(chapterId, 10) !== 1) {
        return this.setState({ openPremiumPopup: true });
      } else {
        const { router } = this.context;
        router.push({
          pathname: nextAwareRoute(appRoutes.CFA1_2025_NOTES_VIEW).replace(':readingId', items.id).replace(
            ':chapterId',
            items[chapterIdKey],
          ),
        });
      }
    }
  };

  onViewList = items => {
    const { isUserSubscribed } = this.state;
    const { chapterId } = this.props.params;
    if (!items[TotalNotesCountKey]) {
      showInformation(messages.NOTES_NOT_AVAILABLE_FOR_READING);
    } else {
      if (!isUserSubscribed && parseInt(chapterId, 10) !== 1) {
        return this.setState({ openPremiumPopup: true });
      } else {
        const { router } = this.context;
        router.push({
          pathname: nextAwareRoute(appRoutes.CFA1_2025_NOTES_LIST).replace(':readingId', items.id).replace(
            ':chapterId',
            items[chapterIdKey],
          ),
        });
      }
    }
  };
  render() {
    const { params } = this.props;
    const { chapterId } = params;
    const {
      chapterName,
      chapterOrder,
      pdfAlert,
      openPremiumPopup,
      isUserSubscribed,
      readingListData,
      isLoading = false,
    } = this.state;
    const { router } = this.context;

    return (
      <div className='animated fadeIn'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader  title={`${chapterOrder !== 0 ? `${chapterOrder}.` : ''} ${chapterName}`}>
          <div>
            <CustomButton
              className='bg-completed-cases overflow-hidden max-width-min-content'
              onClick={() => {
                this.checkSubscription(
                  () =>
                    apiServiceProvider['pdfDownloadViaEmail']({
                      chapterId,
                    }),
                  'Question',
                );
              }}
            >
              <i className='fa fa-download' aria-hidden='true' />
              {!isUserSubscribed && <div className='premium-download'>Premium</div>}
              {messages.DOWNLOAD_NOTE}
            </CustomButton>

            <CustomButton onClick={() => router.push({ pathname: nextAwareRoute(appRoutes.CFA1_2025_NOTES) })}>
              {messages.CHANGE_TOPIC}
            </CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}========================================== */}
        <LoaderWrapper isLoading={isLoading}>
          <ReadingList
            tableName={messages.CHAPTER_READING}
            readingData={readingListData}
            onViewList={this.onViewList}
            isViewListIcon={true}
            onBeginChapter={this.onBeginChapter}
          />
        </LoaderWrapper>
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_frm}
        />

        {/* //* THIS IS PDF DOWNLOAD SUCCESS MODAL POP-UP  */}
        <PDFModelComponent
          type='Study Notes'
          pdfAlertModel={this.pdfAlertModel}
          pdfAlert={pdfAlert}
          PDFContentMessage={messages.PDF_DOWNLOAD_CONTENT_MESSAGE}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ReadingList/ReadingsList.jsx